import { useUpdateContentModuleStatusMutation } from "entities/contentSchedule/mutations/useUpdateContentModuleStatusMutation";
import { useAllBrandsWithAllModulesQuery } from "entities/contentSchedule/queries/useAllBrandsWithAllModulesQuery";
import { ContentSchedule } from "entities/contentSchedule/types";
import { FC, PropsWithChildren } from "react";
import { useDrawerState } from "shared/hooks/useDrawerState";
import { useLocalSearch } from "shared/hooks/useLocalSearch";
import { createContext } from "shared/utils/context";
import { ContentScheduleContextType } from "./types";

const [Provider, useContentSchedule] =
  createContext<ContentScheduleContextType>({
    name: "ContentScheduleContext",
    hookName: "useContentSchedule",
    providerName: "ContentScheduleProvider",
  });

const ContentScheduleProvider: FC<PropsWithChildren> = (props) => {
  const moduleDetailsDrawer = useDrawerState<
    ContentSchedule | null | undefined
  >();
  const { data: contentScheduleList = [], isLoading } =
    useAllBrandsWithAllModulesQuery();

  const { mutate: updateContentModuleStatus } =
    useUpdateContentModuleStatusMutation();

  const searchData = useLocalSearch<ContentSchedule>({
    searchableFields: ["name", "brandId", "pageId"],
    initialData: contentScheduleList || [],
  });

  const value: ContentScheduleContextType = {
    contentSchedule: contentScheduleList,
    searchData: {
      ...searchData,
      isSearchActive: !!searchData.value,
    },
    loading: isLoading,
    updateContentModuleStatus,
    moduleDetailsDrawer,
  };

  return <Provider value={value}>{props.children}</Provider>;
};

export { ContentScheduleProvider, useContentSchedule };
